import { createContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Authenticate } from "../../store/reducers/reducer-auth";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const auth = useSelector((state) => state.RS_Authentication);
  const dispatch = useDispatch();
  const setAuth = (data) => {
    dispatch(Authenticate(data));
  };
  return (
    <AuthContext.Provider value={{ auth: auth, setAuth: setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
